require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./20-yrfixeddisclosure.json") })
        }
      }, "path---20-yrfixeddisclosure");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---20-yrfixeddisclosure!./.cache/json/20-yrfixeddisclosure.json
// module id = 1530
// module chunks = 231608221292675